(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ingenio-bundle-form"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ingenio-bundle-form')) return;
    let busy = false;
    const track = (event, fields = {}) => window.ingenioLaunchTrack?.(event, fields);
    const jsonRequest = async (url, body) => {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(url, {
          method: body ? 'POST' : 'GET', credentials: 'same-origin', signal: controller.signal,
          headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        const value = await response.json();
        if (!response.ok || value.status >= 400) throw new Error(value.description || 'cart_request_failed');
        return value;
      } finally { clearTimeout(timer); }
    };
    customElements.define('ingenio-bundle-form', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.form = this.querySelector('form');
        this.button = this.querySelector('button');
        this.status = this.querySelector('[role="status"]');
        this.recovery = this.querySelector('.il-recovery');
        this.form?.addEventListener('submit', event => this.submit(event));
      }
      async submit(event) {
        event.preventDefault();
        if (busy || this.dataset.preview === 'true') return;
        busy = true;
        const originalLabel = this.button.textContent;
        const variantId = Number(this.form.elements.id.value);
        this.button.disabled = true;
        this.button.textContent = this.dataset.loading;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = '';
        this.recovery.hidden = true;
        let added = false;
        let attemptedAdd = false;
        const hasBundle = cart => cart.items?.some(item => Number(item.variant_id || item.id) === variantId);
        track('ingenio_bundle_click', { product_variant_id: String(variantId) });
        try {
          const cart = await jsonRequest(this.dataset.cartUrl + '.js');
          if (!hasBundle(cart)) {
            attemptedAdd = true;
            await jsonRequest(this.dataset.addUrl + '.js', { items: [{ id: variantId, quantity: 1 }] });
            added = true;
            track('ingenio_bundle_added', { product_variant_id: String(variantId), quantity: 1 });
          } else { added = true; }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (attemptedAdd && !added) {
            try { added = hasBundle(await jsonRequest(this.dataset.cartUrl + '.js')); } catch (_) {}
          }
          this.status.textContent = added ? this.dataset.addedError : this.dataset.error;
          this.recovery.hidden = false;
          this.status.focus();
          track('ingenio_bundle_error', { step: added ? 'cart_redirect' : 'add', recoverable: true });
        } finally {
          busy = false;
          this.button.disabled = false;
          this.button.textContent = originalLabel;
          this.removeAttribute('aria-busy');
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ingenio-launch-analytics"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ingenioLaunchTrack) return;
    const events = new Set(['ingenio_collection_view', 'ingenio_collection_click', 'ingenio_design_click', 'ingenio_bundle_click', 'ingenio_bundle_added', 'ingenio_bundle_error']);
    window.ingenioLaunchTrack = (event, fields = {}) => {
      if (!events.has(event) || !window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return false;
      const destination = document.querySelector('[data-ingenio-analytics]')?.dataset.ga4;
      if (!/^G-[A-Z0-9]+$/.test(destination || '')) return false;
      const payload = { send_to: destination, campaign: 'coleccion_sep_2026', ...fields };
      window.dataLayer = window.dataLayer || [];
      (function () { window.dataLayer.push(arguments); })('event', event, payload);
      document.dispatchEvent(new CustomEvent('ingenio:measurement', { detail: { event, ...payload } }));
      return true;
    };
    if (window.Shopify?.customerPrivacy) {
      document.dispatchEvent(new CustomEvent('ingenio:analytics-ready'));
    } else {
      window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) document.dispatchEvent(new CustomEvent('ingenio:analytics-ready'));
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
